import React from 'react';
import { ItemList, List, Wrapper } from './list-contacts.styles';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { AllEnvelope, AllPhone } from '@vtbhome/juicyfront/indexIcon';
import { ListContactsProps } from './types';

export const ListContacts: React.FC<ListContactsProps> = ({ email, phone }) => {
    return (
        <Wrapper>
            <Typography size='h6'>Контактные данные</Typography>
            <List>
                {email && (
                    <ItemList href={`mailto:${email}`}>
                        <Button buttonType='light' startAdornment={<AllEnvelope />} />
                        <Typography size='button1'>{email}</Typography>
                    </ItemList>
                )}
                {phone && (
                    <ItemList href={`tel:${email}`}>
                        <Button buttonType='light' startAdornment={<AllPhone />} />
                        <Typography size='button1'>{phone}</Typography>
                    </ItemList>
                )}
            </List>
        </Wrapper>
    );
};
